import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import useScrollToTop from "@/hooks/useScrollToTop";
import HeroSection from "@/pages/home/HeroSection";
import StreamingPlatforms from "@/pages/home/StreamingPlatforms";
import FeaturesSection from "@/pages/home/FeaturesSection";
import ServicesSection from "@/pages/home/ServicesSection";
import FeaturedArtistsSection from "@/pages/home/FeaturedArtistsSection";
import TestimonialsSection from "@/pages/home/TestimonialsSection";
import FaqSection from "@/pages/home/FaqSection";
import BlogSection from "@/pages/home/BlogSection";
import CtaSection from "@/pages/home/CtaSection";
import MissionSection from "@/pages/home/MissionSection";
import AboutYouAuxSection from "@/pages/home/AboutYouAuxSection";
import WhyChooseUsSection from "@/pages/home/WhyChooseUsSection";
import { extractValidReturnToUrl, cleanReturnToParameters } from "@/utils/urlUtils";

const Home = () => {
  useScrollToTop();

  // Handle any return_to parameters when landing on homepage
  useEffect(() => {
    // Clean any return_to parameters to avoid unexpected redirects on the marketing site
    const returnToUrl = extractValidReturnToUrl();
    if (returnToUrl) {
      cleanReturnToParameters();
    }
  }, []);

  return (
    <div className="ophira-bg min-h-screen bg-[#0d0d0d]">
      <Helmet>
        <title>YouAux : Free Music Distribution | Best Music Distribution Platform</title>
        <meta name="description" content="Distribute your music to 150+ platforms worldwide. Upload once, distribute everywhere, and keep 100% of ownership with YouAux." />
        <meta name="keywords" content="music distribution platform, free music distribution, best music distribution platform, youaux, streaming platforms, spotify distribution, apple music distribution, music marketing, artist promotion, youtube music distribution, instagram music distribution, free music distributor, youaux entertainment" />
        <link rel="canonical" href="https://youaux.com" />
      </Helmet>
      <Navbar />
      <main className="pt-24">
        <HeroSection />
        <StreamingPlatforms />
        <AboutYouAuxSection />
        <FeaturesSection />
        <MissionSection />
        <ServicesSection />
        <WhyChooseUsSection />
        {/* <FeaturedArtistsSection /> */}
        <TestimonialsSection />
        <FaqSection />
        {/* <BlogSection /> */}
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
